import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=3979bea8&scoped=true"
import script from "./Forms.vue?vue&type=script&setup=true&lang=js"
export * from "./Forms.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979bea8",
  null
  
)

export default component.exports